(function () {
  class UbiquitiHero extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.dots = [];
      this.current = 0;
      this.timer = null;
      this.paused = false;
      this.touchStartX = null;
      this.onMouseEnter = () => this.pause();
      this.onMouseLeave = () => this.resume();
      this.onFocusIn = () => this.pause();
      this.onFocusOut = () => this.resume();
      this.onKeyDown = (e) => this.handleKey(e);
      this.onTouchStart = (e) => { this.touchStartX = e.changedTouches[0].clientX; };
      this.onTouchEnd = (e) => this.handleTouchEnd(e);
    }

    connectedCallback() {
      this.viewport = this.querySelector('.ubiquiti-hero__viewport');
      this.slides = Array.from(this.querySelectorAll('.ubiquiti-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.ubiquiti-hero__dot'));
      const prev = this.querySelector('.ubiquiti-hero__arrow--prev');
      const next = this.querySelector('.ubiquiti-hero__arrow--next');

      if (this.slides.length <= 1) {
        this.hideControls();
        return;
      }

      if (prev) prev.addEventListener('click', () => this.go(this.current - 1, true));
      if (next) next.addEventListener('click', () => this.go(this.current + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

      this.viewport.addEventListener('mouseenter', this.onMouseEnter);
      this.viewport.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      this.viewport.addEventListener('keydown', this.onKeyDown);
      this.viewport.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.viewport.addEventListener('touchend', this.onTouchEnd, { passive: true });

      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    hideControls() {
      const controls = this.querySelectorAll('.ubiquiti-hero__arrows, .ubiquiti-hero__dots');
      controls.forEach((el) => el.remove());
    }

    go(index, userInitiated) {
      const total = this.slides.length;
      const target = ((index % total) + total) % total;
      if (target === this.current) return;

      this.slides[this.current].classList.remove('is-active');
      if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');

      this.current = target;

      this.slides[this.current].classList.add('is-active');
      if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');

      this.dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === this.current ? 'true' : 'false'));

      if (userInitiated) this.restartAutoplay();
    }

    handleKey(e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.go(this.current - 1, true);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.go(this.current + 1, true);
      }
    }

    handleTouchEnd(e) {
      if (this.touchStartX === null) return;
      const delta = e.changedTouches[0].clientX - this.touchStartX;
      if (Math.abs(delta) > 40) {
        this.go(this.current + (delta < 0 ? 1 : -1), true);
      }
      this.touchStartX = null;
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      const interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 6000);
      this.timer = window.setInterval(() => {
        if (!this.paused && !document.hidden) this.go(this.current + 1, false);
      }, interval);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    pause() {
      this.paused = true;
    }

    resume() {
      this.paused = false;
    }
  }

  if (!customElements.get('ubiquiti-hero')) {
    customElements.define('ubiquiti-hero', UbiquitiHero);
  }
})();
